import styled from 'styled-components';
import { CUSTOM_TYPOGRAPHY_CSS, type CustomTypographyProps } from './custom-typography';

export const H3 = styled.h3<CustomTypographyProps>`
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;

  ${CUSTOM_TYPOGRAPHY_CSS};
`;
